export default __webpack_public_path__ + "static/star-70708491559d604478d3c7fcc09cead4.png";